import {
   CombinationExplorer,
   ProjectSettings,
   Rewards,
   Variables,
} from "@views/index"
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import {
   onboardedGuard,
   projectGuard,
   subscriptionProjectGuard,
} from "../guards/composable"
import InstallationInstructions from "@views/InstallationInstructions.vue"
import Overview from "@views/Overview.vue"
import VariableExplorer from "@views/VariableExplorer.vue"
import { useProjectStore } from "@stores/projectStore"

export default [
   {
      name: "Variables",
      path: "/orgs/:orgSlug/projects/:projectId/variables",
      component: Variables,
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "CreateBasicVariable",
      path: "/orgs/:orgSlug/projects/:projectId/variables/basic/create",
      component: () => import("@views/CreateBasicVariable.vue"),
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "CreateVisualVariable",
      path: "/orgs/:orgSlug/projects/:projectId/variables/visual/create",
      component: () => import("@views/CreateVisualVariable.vue"),
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "EditBasicVariable",
      path: "/orgs/:orgSlug/projects/:projectId/variables/basic/:variableId",
      component: () => import("@views/EditBasicVariable.vue"),
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "EditVariable",
      path: "/orgs/:orgSlug/projects/:projectId/variables/:variableId",
      component: () => import("@views/VariableEditor.vue"),
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "Rewards",
      path: "/orgs/:orgSlug/projects/:projectId/rewards",
      component: Rewards,
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "ProjectSettings",
      path: "/orgs/:orgSlug/projects/:projectId/settings",
      component: ProjectSettings,
      meta: {
         layout: "ProjectLayout",
         tab: "settings",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "ProjectSettingsInstall",
      path: "/orgs/:orgSlug/projects/:projectId/settings/install",
      component: ProjectSettings,
      meta: {
         layout: "ProjectLayout",
         tab: "install",
      },
      // Using projectGuard (not subscriptionProjectGuard) to allow access during trials/onboarding
      // Users need to see installation instructions before they can set up tracking
      beforeEnter: projectGuard,
   },
   {
      name: "ProjectSettingsTours",
      path: "/orgs/:orgSlug/projects/:projectId/settings/tours",
      component: ProjectSettings,
      meta: {
         layout: "ProjectLayout",
         tab: "tours",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "CombinationExplorer",
      path: "/orgs/:orgSlug/projects/:projectId/combination-explorer",
      component: CombinationExplorer,
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "VariableExplorer",
      path: "/orgs/:orgSlug/projects/:projectId/variable-explorer",
      component: VariableExplorer,
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "InstallationInstructions",
      path: "/orgs/:orgSlug/projects/:projectId/install",
      component: InstallationInstructions,
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: subscriptionProjectGuard,
   },
   {
      name: "ProjectHome",
      path: "/orgs/:orgSlug/projects/:projectId",
      component: Overview,
      meta: {
         layout: "ProjectLayout",
      },
      beforeEnter: async (
         to: RouteLocationNormalized,
         from: RouteLocationNormalized,
         next: NavigationGuardNext,
      ) => {
         const projectStore = useProjectStore()
         // Set the project ID and load project settings
         projectStore.projectId = Number(to.params.projectId)

         return onboardedGuard(to, from, next)
      },
   },
]
